import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { licenseAgreementAcceptLogCompartments, licenseAgreementAcceptLogStorageKey } from '..';

export class LicenseAgreementAcceptLogListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.LicenseAgreementInitialized)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(licenseAgreementAcceptLogStorageKey)
    private readonly cache: DataCache<licenseAgreementAcceptLogCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('licenseAgreementAcceptLog');
        } else {
          this.cache.reset('licenseAgreementAcceptLog');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
